// extracted by mini-css-extract-plugin
export default {"sc_wem":"index_sc_wem_LjuT-"};